import { Promocao } from './promocao.model';
import { NTECH_API } from './../app.api';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ErrorHandler } from './../app.error-handler';

@Injectable()
export class PromocaoService {

    constructor(private http: Http){}

    getPromocoes(): Observable<Promocao[]> {
        return this.http.get(`${NTECH_API}/promocao`)
        .map(response => response.json())
        .catch(ErrorHandler.handleError);
    }
}


// WEBPACK FOOTER //
// ./src/app/promocao/promocao.service.ts